<template>
  <p>
    <button @click="onPaylateClick">
      {{ $t('paylateBtn') }}
    </button>
  </p>
</template>

<script>
export default {
  name: 'Paylate',
  props: {
    product: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  metaInfo: {
    script: [
      {
        src: 'https://paylate.com.ua/js/jquery.maskedinput.min.js',
      },
    ],
    link: [{ rel: 'stylesheet', href: 'https://paylate.com.ua/js/credit.css' }],
  },
  methods: {
    onPaylateClick() {
      const price = this.product.newPrice
        ? this.product.newPrice
        : this.product.price
      const name =
        this.product[`name_${this.$i18n.locale}`] || this.product.name
      window.buyInCredit(price, name)
    },
  },
  beforeMount() {
    window.pl_options = {
      pl_type: 2,
      pl_n1: 'Три платежі',
      pl_n2: 'Шість платежів',
      pl_n3: 'Десять платежів',
      pl_bc: '#4e6bb2',
    }
  },
}
</script>

<style>
#preCreditWindow .buttons_pl,
#creditWindowId .buttons_pl {
  background-color: #fd9427;
}
#preCreditWindow .buttons_pl:hover,
#creditWindowId .buttons_pl:hover {
  background-color: rgba(255, 67, 0, 0.9);
}
#preCreditWindow .buttons_pl:disabled,
#creditWindowId .buttons_pl:disabled {
  background-color: grey;
}
</style>
